var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Dialog, Stack } from "@mui/material";
import { DataGridPremium, gridClasses, GridPreferencePanelsValue, useGridApiRef } from "@mui/x-data-grid-premium";
import { nanoid } from "@reduxjs/toolkit";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { CheckboxOutlinedBase } from "../../../assets/images";
import { secondary } from "../../../theme/colors";
import CellErrorIcon from "./components/cellErrorIcon";
import EditableGridToolbar from "./components/editableGridToolbar";
import GridCellWrapper from "./components/gridCellWrapper";
import { renderGridEditCell } from "./components/renderGridEditCell";
export var EditableDataGrid = function (props) {
    var _a, _b;
    var _dataGridProps$slotPr, _dataGridProps$slotPr2;
    var onChange = props.onChange, columns = props.columns, _c = props.rows, rows = _c === void 0 ? [] : _c, _d = props.dataGridProps, dataGridProps = _d === void 0 ? {} : _d, _e = props.validationModel, validationModel = _e === void 0 ? {} : _e, _f = props.isCollapsible, isCollapsible = _f === void 0 ? false : _f, _g = props.dataGridHeader, dataGridHeader = _g === void 0 ? "" : _g, dataGridHeaderProps = props.dataGridHeaderProps, _h = props.cellInfoModel, cellInfoModel = _h === void 0 ? {} : _h, _j = props.disableAddRow, disableAddRow = _j === void 0 ? false : _j, _k = props.disableDeleteRow, disableDeleteRow = _k === void 0 ? false : _k, _l = props.initialCollapsed, initialCollapsed = _l === void 0 ? false : _l, error = props.error, disableToolbarActions = props.disableToolbarActions, disableActionsMenu = props.disableActionsMenu, visibleActions = props.visibleActions, onToolbarButtonClick = props.onToolbarButtonClick, getToolbarActions = props.getToolbarActions, onRowExpansion = props.onRowExpansion;
    var gridApi = useGridApiRef();
    var _m = useState(), errors = _m[0], setErrors = _m[1];
    var _o = useState(initialCollapsed), collapse = _o[0], setCollapse = _o[1];
    var _p = useState(false), expand = _p[0], setExpand = _p[1];
    var _q = useState({}), expandedRows = _q[0], setExpandedRows = _q[1];
    var _r = useState(), columnVisibilityModel = _r[0], setColumnVisibilityModel = _r[1];
    var handleRowExpansion = useCallback(function (params, e, details) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (onRowExpansion === null || onRowExpansion === void 0 ? void 0 : onRowExpansion(params, e, details))];
                case 1:
                    _a.sent();
                    setExpandedRows(function (prev) {
                        var _a;
                        return _objectSpread(_objectSpread({}, prev), {}, (_a = {},
                            _a[params.id] = Boolean(params.childrenExpanded),
                            _a));
                    });
                    return [2 /*return*/];
            }
        });
    }); }, [onRowExpansion, setExpandedRows]);
    useEffect(function () {
        var cleanUp;
        if (onRowExpansion)
            cleanUp = gridApi.current.subscribeEvent('rowExpansionChange', handleRowExpansion);
        return function () {
            var _cleanUp;
            (_cleanUp = cleanUp) === null || _cleanUp === void 0 || _cleanUp();
        };
    }, []);
    useEffect(function () {
        Object.entries(expandedRows).forEach(function (_ref) {
            var rowId = _ref[0], expanded = _ref[1];
            gridApi.current.setRowChildrenExpansion(rowId, expanded);
        });
    }, [rows, error === null || error === void 0 ? void 0 : error.id]);
    useEffect(function () {
        processError(error);
    }, [error === null || error === void 0 ? void 0 : error.id]);
    var processError = useCallback(function (error) {
        if (error !== null && error !== void 0 && error.rowId && error !== null && error !== void 0 && error.field) {
            var cellParams = gridApi.current.getCellParams(error.rowId, error.field);
            var cellMode = gridApi.current.getCellMode(error === null || error === void 0 ? void 0 : error.rowId, error === null || error === void 0 ? void 0 : error.field);
            if (cellMode === 'view' && cellParams.isEditable) {
                gridApi.current.startCellEditMode({
                    id: error === null || error === void 0 ? void 0 : error.rowId,
                    field: error === null || error === void 0 ? void 0 : error.field
                });
            }
        }
        gridApi.current.setState(function (prev) { return _objectSpread(_objectSpread({}, prev), {}, {
            error: error
        }); });
    }, []);
    var processRowUpdate = useCallback(function (newRow, oldRow, params) { return __awaiter(void 0, void 0, void 0, function () {
        var _await$dataGridProps$, _dataGridProps$proces, currRow, newRows;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currRow = _objectSpread({}, newRow);
                    delete currRow.errors;
                    return [4 /*yield*/, ((_dataGridProps$proces = dataGridProps.processRowUpdate) === null || _dataGridProps$proces === void 0 ? void 0 : _dataGridProps$proces.call(dataGridProps, currRow, oldRow, params))];
                case 1:
                    currRow = (_await$dataGridProps$ = _a.sent()) !== null && _await$dataGridProps$ !== void 0 ? _await$dataGridProps$ : currRow;
                    newRows = rows.map(function (row) { return row.id === currRow.id ? currRow : row; });
                    if (!onChange) return [3 /*break*/, 3];
                    return [4 /*yield*/, onChange(null, newRows)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, currRow];
            }
        });
    }); }, [gridApi, columns, rows, onChange]);
    var handleAddRow = useCallback(function (e) {
        var colIndex = columns.findIndex(function (col) { return col.editable; });
        if (colIndex === -1 || errors !== null && errors !== void 0 && errors.message)
            return;
        var newRow = {
            id: nanoid(4)
        };
        var newRows = __spreadArray(__spreadArray([], rows, true), [newRow], false);
        if (onChange)
            onChange(e, newRows);
        gridApi.current.scrollToIndexes({
            rowIndex: rows.length,
            colIndex: colIndex
        });
    }, [columns, errors, rows, onChange]);
    var preProcessEditCellPropsWrapper = useCallback(function (params, processor) { return __awaiter(void 0, void 0, void 0, function () {
        var _await$processor, _await$validationMode, _validationModel$para, inputProps, newProps, errorMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    inputProps = {
                        error: false,
                        startAdornment: null
                    };
                    return [4 /*yield*/, (processor === null || processor === void 0 ? void 0 : processor(params))];
                case 1:
                    newProps = (_await$processor = _a.sent()) !== null && _await$processor !== void 0 ? _await$processor : params.props;
                    return [4 /*yield*/, ((_validationModel$para = validationModel[params.field]) === null || _validationModel$para === void 0 ? void 0 : _validationModel$para.call(validationModel, newProps.value, params.row, gridApi.current.getRowModels()))];
                case 2:
                    errorMessage = (_await$validationMode = _a.sent()) !== null && _await$validationMode !== void 0 ? _await$validationMode : newProps.error;
                    if (errorMessage) {
                        inputProps = {
                            error: true,
                            startAdornment: /*#__PURE__*/ React.createElement(CellErrorIcon, {
                                error: errorMessage
                            })
                        };
                        console.warn(params.field, ":", errorMessage);
                        setErrors({
                            id: nanoid(3),
                            rowId: params.id,
                            field: params.field,
                            value: newProps.value,
                            message: errorMessage
                        });
                    }
                    else
                        setErrors(undefined);
                    return [2 /*return*/, _objectSpread(_objectSpread(_objectSpread({}, newProps), inputProps), {}, {
                            changeReason: "debouncedSetEditCellValue"
                        })];
            }
        });
    }); }, [validationModel]);
    var preProcessedColumns = useMemo(function () {
        var newColumns = columns.map(function (col) {
            var _col$renderEditCell;
            return _objectSpread(_objectSpread({}, col), {}, {
                preProcessEditCellProps: function (params) {
                    return __awaiter(this, void 0, void 0, function () {
                        var newParams;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    newParams = _objectSpread(_objectSpread({}, params), {}, {
                                        field: col.field
                                    });
                                    return [4 /*yield*/, preProcessEditCellPropsWrapper(newParams, col.preProcessEditCellProps)];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        });
                    });
                },
                renderCell: col.type === 'actions' ? col.renderCell : function (params) {
                    var _col$renderCell;
                    return /*#__PURE__*/ React.createElement(GridCellWrapper, _extends({}, params, {
                        info: cellInfoModel[params.field],
                        cell: (_col$renderCell = col.renderCell) === null || _col$renderCell === void 0 ? void 0 : _col$renderCell.call(col, params)
                    }));
                },
                renderEditCell: (_col$renderEditCell = col.renderEditCell) !== null && _col$renderEditCell !== void 0 ? _col$renderEditCell : renderGridEditCell
            });
        });
        return newColumns;
    }, [columns, gridApi, validationModel]);
    var handleToolbarClick = useCallback(function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var name, success, _a, selected_1, newRows;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    name = e.currentTarget.id;
                    if (!name)
                        return [2 /*return*/];
                    return [4 /*yield*/, (onToolbarButtonClick === null || onToolbarButtonClick === void 0 ? void 0 : onToolbarButtonClick(e, {
                            rows: rows,
                            errors: error !== null && error !== void 0 ? error : errors,
                            api: gridApi
                        }))];
                case 1:
                    success = _b.sent();
                    if (success === false)
                        return [2 /*return*/];
                    _a = name;
                    switch (_a) {
                        case 'delete': return [3 /*break*/, 2];
                        case 'add': return [3 /*break*/, 3];
                        case 'maximize': return [3 /*break*/, 4];
                        case 'manageColumns': return [3 /*break*/, 5];
                        case 'export': return [3 /*break*/, 6];
                    }
                    return [3 /*break*/, 8];
                case 2:
                    selected_1 = gridApi.current.getSelectedRows();
                    if (!selected_1.size)
                        return [2 /*return*/];
                    newRows = rows.filter(function (r) { return !selected_1.has(r.id); });
                    if (onChange)
                        onChange(e, newRows);
                    return [3 /*break*/, 8];
                case 3:
                    handleAddRow(e);
                    return [3 /*break*/, 8];
                case 4:
                    setExpand(function (prev) { return !prev; });
                    return [3 /*break*/, 8];
                case 5:
                    gridApi.current.showPreferences(GridPreferencePanelsValue.columns, name, name);
                    return [3 /*break*/, 8];
                case 6: return [4 /*yield*/, gridApi.current.exportDataAsExcel({
                        includeHeaders: true,
                        allColumns: true
                    })];
                case 7: return [2 /*return*/, _b.sent()];
                case 8: return [2 /*return*/];
            }
        });
    }); }, [rows, onChange, setExpand, onToolbarButtonClick, gridApi.current, handleAddRow, error, errors]);
    var actions = useMemo(function () { return getToolbarActions === null || getToolbarActions === void 0 ? void 0 : getToolbarActions({
        rows: rows,
        errors: error !== null && error !== void 0 ? error : errors,
        api: gridApi
    }); }, [rows, errors, error]);
    var Container = expand ? Dialog : React.Fragment;
    var containerDefaultProps = expand ? {
        open: expand,
        maxWidth: 'xl',
        fullWidth: true,
        onClose: function () { return setExpand(false); },
        PaperProps: {
            sx: {
                borderRadius: 2
            }
        }
    } : {};
    return /*#__PURE__*/ React.createElement(Container, containerDefaultProps, /*#__PURE__*/ React.createElement(Stack, {
        minHeight: collapse ? 'auto' : 150,
        maxHeight: expand ? '80svh' : 400
    }, /*#__PURE__*/ React.createElement(DataGridPremium, _extends({
        density: "compact",
        showColumnVerticalBorder: true,
        apiRef: gridApi,
        columns: preProcessedColumns,
        rows: rows,
        columnHeaderHeight: 44,
        rowHeight: 68,
        filterDebounceMs: 300,
        disableRowGrouping: true
        // getRowHeight={(params) =>
        //     params.id === GRID_AGGREGATION_ROOT_FOOTER_ROW_ID ? 44
        //         : 68}
    }, dataGridProps, {
        processRowUpdate: processRowUpdate,
        isCellEditable: function (params) {
            var isEditable = dataGridProps.isCellEditable ? dataGridProps.isCellEditable(params) : true;
            var isError = !(errors !== null && errors !== void 0 && errors.message) || Boolean(errors.rowId === params.id && errors.field === params.field && errors.message);
            return isEditable && isError;
        },
        columnVisibilityModel: columnVisibilityModel,
        onColumnVisibilityModelChange: function (newModel) {
            setColumnVisibilityModel(newModel);
        },
        slots: _objectSpread({
            toolbar: EditableGridToolbar
        }, dataGridProps.slots),
        slotProps: _objectSpread(_objectSpread({}, dataGridProps.slotProps), {}, {
            toolbar: _objectSpread({
                isCollapsible: !expand && isCollapsible,
                dataGridHeader: dataGridHeader,
                titleTypographyProps: dataGridHeaderProps,
                chipLabel: rows === null || rows === void 0 ? void 0 : rows.length,
                collapse: collapse,
                setCollapse: setCollapse,
                disableToolbarActions: disableToolbarActions,
                visibleActions: _objectSpread({
                    add: !disableAddRow,
                    delete: !disableDeleteRow
                }, visibleActions),
                onToolbarButtonClick: handleToolbarClick,
                actions: actions,
                disableActionsMenu: disableActionsMenu
            }, (_dataGridProps$slotPr = dataGridProps.slotProps) === null || _dataGridProps$slotPr === void 0 ? void 0 : _dataGridProps$slotPr.toolbar),
            root: _objectSpread({
                onPasteCapture: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }, (_dataGridProps$slotPr2 = dataGridProps.slotProps) === null || _dataGridProps$slotPr2 === void 0 ? void 0 : _dataGridProps$slotPr2.root),
            baseCheckbox: {
                icon: /*#__PURE__*/ React.createElement(CheckboxOutlinedBase, {
                    fill: "white",
                    stroke: secondary[200]
                })
            }
        }),
        localeText: _objectSpread({
            noResultsOverlayLabel: 'No records found',
            noRowsLabel: 'No records found'
        }, dataGridProps.localeText),
        sx: _objectSpread((_a = {
                '--DataGrid-containerBackground': 'background.secondary',
                '--DataGrid-pinnedBackground': 'white',
                borderRadius: 2,
                fontSize: {
                    xs: 'sm'
                },
                // color: mobilenoblack,
                ".Mui-error": {
                    color: 'error.main',
                    backgroundColor: 'error.50',
                    fontSize: 'inherit'
                }
            },
            _a[".".concat(gridClasses.virtualScroller)] = {
                minHeight: '150px',
                display: collapse ? 'none' : undefined
            },
            _a[".".concat(gridClasses.virtualScrollerContent)] = {
                bgcolor: 'white'
            },
            _a[".".concat(gridClasses["scrollbar--horizontal"])] = {
                bgcolor: 'background.secondary'
            },
            _a[".".concat(gridClasses['pinnedRows--bottom'], ",.").concat(gridClasses.columnHeaders)] = (_b = {},
                _b["& .".concat(gridClasses.scrollbarFiller, ".").concat(gridClasses["scrollbarFiller--pinnedRight"])] = {
                    bgcolor: 'background.secondary'
                },
                _b),
            _a[" .".concat(gridClasses.scrollbarFiller, ".").concat(gridClasses["scrollbarFiller--pinnedRight"])] = {
                bgcolor: 'background.secondary'
            },
            _a["& .".concat(gridClasses.columnHeader)] = {
                // borderRight: `1px solid`,
                // borderColor: 'secondary.200',
                color: 'text.secondary',
                backgroundColor: 'background.secondary',
                fontWeight: 'medium',
                px: 3
            },
            _a["& .".concat(gridClasses.columnHeader, "[data-field='__check__']")] = {
                px: 0
            },
            _a["& .".concat(gridClasses.editInputCell)] = {
                fontSize: 'inherit',
                px: 3,
                '& input': {
                    px: 0
                }
            },
            _a["& .".concat(gridClasses.checkboxInput)] = {
                color: 'secondary.200'
            },
            _a["& #cell-icon"] = {
                display: 'none',
                height: 16,
                width: 16
            },
            _a["& .".concat(gridClasses.row, ":hover #cell-icon")] = {
                display: 'unset'
            },
            _a["& .".concat(gridClasses.cell, ":focus-within #cell-icon")] = {
                display: 'unset'
            },
            _a["& .".concat(gridClasses.aggregationColumnHeaderLabel)] = {
                // position: 'static',
                // fontSize: 10,
                // lineHeight: 1.5,
                // textTransform: 'none',
                // color: 'inherit',
                display: 'none'
            },
            _a["& .".concat(gridClasses.overlay)] = {
                color: 'text.tertiary',
                backgroundColor: 'white'
            },
            _a["& .".concat(gridClasses['pinnedRows--bottom'], " .").concat(gridClasses.cell)] = {
                fontWeight: 'medium',
                backgroundColor: 'background.secondary'
            },
            _a["& .Mui-checked"] = {
                color: 'primary.main'
            },
            _a), dataGridProps.sx)
    }))));
};
